import React, { useState } from "react";
import { Link } from "react-router-dom";

const Logo = () => {
  const [imageError, setImageError] = useState(false);

  // If image fails to load, show text fallback
  if (imageError) {
    return (
      <Link
        to="/"
        className="flex items-center transition-transform duration-200 hover:scale-105"
        aria-label="Street Lawyer Services Home"
      >
        <span className="text-white font-bold text-xl">
          Street Lawyer Services
        </span>
      </Link>
    );
  }

  return (
    <Link
      to="/"
      className="flex items-center transition-transform duration-200 hover:scale-105"
      aria-label="Street Lawyer Services Home"
    >
      <picture>
        {/* WebP version - modern browsers */}
        <source
          srcSet="/images/logo/street-lawyer-services-logo.webp"
          type="image/webp"
        />
        {/* PNG fallback for browsers without WebP support */}
        <img
          src="/images/logo/street-lawyer-services-logo.png"
          alt="Street Lawyer Services Logo"
          className="h-10 md:h-12"
          loading="eager"
          fetchPriority="high"
          onError={() => setImageError(true)}
        />
      </picture>
    </Link>
  );
};

export default React.memo(Logo);
